export default __webpack_public_path__ + "static/media/CNo.65-2.b6a496ce.jpg";